import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
    onProceed: (amount: string, reason: string) => void;
}

export default function TakeReturnAction({
    open,
    onClose,
    setOpen,
    onProceed,
}: ModalProps) {
    const [amount, setAmount] = useState("");
    const [reason, setReason] = useState("");

    const handleSubmit = () => {
        onProceed(amount, reason);
        setOpen(false);
        setAmount("");
        setReason("");
    };

    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Refund</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <form className="form" onSubmit={(e) => e.preventDefault()}>
                        <div className="control_group">
                            <label htmlFor="refund-amount">Refund Amount</label>
                            <TextField
                                placeholder="Enter refund amount"
                                fullWidth
                                hiddenLabel
                                type="number"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                inputProps={{ id: "refund-amount" }}
                            />
                        </div>

                        <div className="control_group">
                            <label htmlFor="refund-reason">Reason for Refund Amount</label>
                            <TextField
                                placeholder="Enter reason for the refund amount..."
                                fullWidth
                                hiddenLabel
                                multiline
                                rows={4}
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                inputProps={{ id: "refund-reason" }}
                            />
                        </div>

                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={handleSubmit}
                            >
                                Proceed with Refund
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
